module.exports = __webpack_public_path__ + "img/cc.2a1c7189.png";